import { render } from "./VContact.vue?vue&type=template&id=f8361adc"
import script from "./VContact.vue?vue&type=script&lang=js"
export * from "./VContact.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__